"use strict";

exports.__esModule = true;
exports.setDebugMode = void 0;

var _cookie = require("./cookie");

const setDebugMode = debugEnabled => {
  switch (debugEnabled.type) {
    case 'cookie':
      return (0, _cookie.getCookie)(debugEnabled.key) === debugEnabled.value;

    default:
      return false;
  }
};

exports.setDebugMode = setDebugMode;